/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import useIterateModifiers from '@/hooks/useIterateModifiers';
import CONST from '@/utils/Constants/General';

const RadioButton = ({
  id,
  name,
  label,
  imgPath,
  value,
  isChecked,
  modifiers,
  onChange,
  onClick,
}) => {
  const modifiersString = useIterateModifiers('dln-radioBtn--', modifiers);
  return (
    <span className={`dln-radioBtn ${modifiersString}`}>
      <input
        id={id}
        name={name || id}
        className='dln-radioBtn__input dln-outline'
        type='radio'
        defaultValue={value}
        onChange={onChange}
        onClick={onClick}
        checked={isChecked}
      />
      <label htmlFor={id} className='dln-radioBtn__lbl'>
        {imgPath ? (
          <img
            alt={label}
            className='dln-radioBtn__imgLabel'
            src={`${CONST.PATH.ASSETS.IMAGES}/${imgPath}`}
          />
        ) : (
          label
        )}
      </label>
    </span>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  imgPath: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  modifiers: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

RadioButton.defaultProps = {
  name: null,
  imgPath: null,
  value: null,
  isChecked: null,
  onClick: () => {},
  modifiers: [],
};

export default RadioButton;
